export const IS_DEBAG = false;
export const IS_DEBAG_FILE = IS_DEBAG && false;

export const _log = (...values) => {
  if (IS_DEBAG) {
    console.log(...values);
  }
};

export const _err = (...values) => {
  if (IS_DEBAG) {
    console.error(...values);
  }
};
